import UserService from '../services/userService';

/**
 * Resolve numeric DPG userId from profile when missing on auth user
 * (Fidost Core auth stores id only).
 */
export const resolveUserId = async (user) => {
  if (!user) return null;
  if (user.userId != null) return user.userId;

  try {
    const result = await UserService.getCurrentUserProfile();
    const profile = result.data?.data || result.data;
    if (result.success && profile?.userId != null) {
      return profile.userId;
    }
  } catch (error) {
    console.error('Error resolving userId from profile:', error);
  }

  return null;
};

export const enrichUserWithProfile = async (user) => {
  if (!user) return null;
  if (user.userId != null) return user;

  const userId = await resolveUserId(user);
  if (userId == null) return user;

  return { ...user, userId };
};

export default resolveUserId;
